export default {
	操作成功: '完了',
	操作失败: '操作に失敗しました',
	产品: '製品',
	当余额不足时使用信用卡自动续费: '残高不足の場合はクレジットカードで自動更新します',
	订单: '注文',
	订单自动续费: '注文の自動更新',
	概览: '概要',
	个: '件',
	更换: '変更',
	获取全部: 'すべて表示',
	解除自动扣款: '自動引き落としを解除',
	确认解除自动扣款吗: 'このカードの自動引き落としを解除しますか？',
	使用信用卡: 'カードを使用',
	使用账户余额: '残高を使用',
	首选信用卡: '優先カード',
	搜索订单号或IP: '注文番号またはIPで検索',
	未设置: '未設定',
	下次续费: '次回更新',
	下次续费日期: '次回更新日',
	下次支付日期: '次回支払日',
	续费订单: '更新注文',
	续费记录: '更新履歴',
	账单周期: '請求期間',
	扣款方式: '決済方法',
	失败原因: '失敗理由',
	续费日历: '更新カレンダー',
	选择信用卡: 'カード選択',
	优先使用可用余额进行自动续费: '利用可能な残高を優先して自動更新します',
	暂无订单: '注文なし',
	账户余额: '残高',
	自动续费: '自動更新',
	自动续费费用: '自動更新費用',
	自动续费服务: '自動更新サービス',
	自动续费设置: '自動更新設定',
	自动续费说明:
		'注文の有効期限の3日前に請求書を自動生成します。自動更新を有効にした注文は、設定に応じて口座残高・登録済みクレジットカードを順番に、またはいずれか一方で自動引き落としを試みます！',
}
